import base from "/app/images/facebook.svg?svg";
import { getResizer } from "svg-merge-attributes";
export default getResizer(base, "");